module.exports = __webpack_public_path__ + "img/printer-white.617162a6.svg";